import React, { useState } from 'react';
import { useNavigate, useParams , useLocation} from 'react-router-dom';
import { ILLUSTRATIONS } from './Ilustrations'; // データの場所に合わせて
import { getTagLabel } from './options';
import { motion, AnimatePresence } from 'framer-motion';

import Modal from '../../components/Modal'; // 以前作ったModalパーツ

import PageTitle from "../../components/PageTitle";




const ModalDetail = () => {
	const location = useLocation();
	const background = location.state?.backgroundLocation;

	const { id } = useParams();
	const navigate = useNavigate();

	// 複数画像対応のためのインデックス管理
	const illust = ILLUSTRATIONS.find((item) => String(item.id) === String(id));

	// imagesプロパティを優先し、なければsrcをチェック。srcが配列ならそのまま使い、文字列なら配列化する
	const images: string[] = (illust as any)?.images || 
		(Array.isArray(illust?.src) ? (illust.src as string[]) : (illust?.src ? [illust.src as string] : []));
	const [currentImgIdx, setCurrentImgIdx] = useState(0);
	const [direction, setDirection] = useState(0); // 1: 次へ(左へ流れる), -1: 前へ(右へ流れる)
	const [isHovered, setIsHovered] = useState(false);
	
	// 触覚フィードバック
	type VibePattern = number | number[];
	
	const triggerHaptic = (pattern: VibePattern) => {
		if (typeof window !== "undefined" && window.navigator && window.navigator.vibrate) {
			window.navigator.vibrate(pattern as any);
		}
	};
	
  const [likeCount, setLikeCount] = React.useState(0);

  // いいね数を取得
  React.useEffect(() => {
    const fetchCurrentLike = async () => {
      try {
        const res = await fetch(`/likes.php?t=${Date.now()}`);
        const data = await res.json();
        // このイラストのIDに一致するカウントを探す
        const target = data.find((item: any) => item.illust_id === id);
        if (target) setLikeCount(parseInt(target.count));
      } catch (e) { console.error(e); }
    };
    fetchCurrentLike();
  }, [id]);

  // IDが変わったらインデックスをリセット
  React.useEffect(() => {
    setCurrentImgIdx(0);
	setDirection(0);
  }, [id]);

  const handleNext = () => {
	setDirection(1);
	setCurrentImgIdx((prev) => (prev + 1) % images.length);
  };
  const handlePrev = () => {
	setDirection(-1);
	setCurrentImgIdx((prev) => (prev - 1 + images.length) % images.length);
  };

  // アンマウント時の処理
  React.useEffect(() => {
    return () => {
      document.title = "Gallery | 毒と花と６畳間";
    };
  }, []);

  // 全てのHooksを呼び出した後に早期リターンを行う
  if (!illust) return null;

  const pageTitle = illust.title?.trim() || "無題";

  // --- デバッグ用のログ ---
  console.log("モーダルで探しているID:", id);
  console.log("見つかったデータ:", illust);


  // いいね送信関数
  const handleLikeInModal = async () => {

	const storageKey = `liked_${id}`;
  	const isAlreadyLiked = localStorage.getItem(storageKey);

  // 送信するアクションを決める
  	const action = isAlreadyLiked ? 'minus' : 'plus';

	console.log("--- 送信データチェック ---");
	console.log("ID:", id);
	console.log("Action:", action);
	console.log("StorageKey:", storageKey);

    try {
		const res = await fetch(`/likes.php?t=${Date.now()}`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },

			body: JSON.stringify({ 
				id: id, 
				action: action 
			})
			
		});

		if (res.ok) {
			const debugData = await res.json();
  			console.log("PHPからの返事:", debugData);
			
			//いいねを配列で保存する
			const currentLikes = localStorage.getItem('my_likes');
  			let likedList: string[] = currentLikes ? JSON.parse(currentLikes) : [];

			if (isAlreadyLiked) {
			// キャンセル処理
			setLikeCount(prev => Math.max(0, prev - 1)); // 0以下にはならないように
			localStorage.removeItem(storageKey); // ローカルストレージから削除

			triggerHaptic(15);

			// 配列からも削除する
    		likedList = likedList.filter(likedId => likedId !== id);

		} else {
			// いいね処理
			setLikeCount(prev => prev + 1);
			localStorage.setItem(storageKey, "true"); // ローカルストレージに保存

			triggerHaptic(500); // いいねしたときに長めに震える

			// 配列に新しく追加する（まだ入っていなければ）
			if (id && !likedList.includes(id)) {
				likedList.push(id);
			}
			
		}
		
		//いいねした配列を保存
		localStorage.setItem('my_likes', JSON.stringify(likedList));
		
      }
    } catch (err) { 
		console.error("いいね操作に失敗しました:",err); 
		triggerHaptic([50, 50, 50]);
	}
  };

  //いいねボタン用（トグル）
  const isAlreadyLiked = localStorage.getItem(`liked_${id}`);








  return (

    <Modal 
      isOpen={true} 
      onClose={() => {
		triggerHaptic(10);
        // 背景（Galleryから来た情報）があるなら戻る、ないならGalleryページへ飛ばす
        if (background) {
          navigate(-1);
        } else {
          navigate('/gallery'); // または navigate('/')
        }
      }}
    >

	{/* タイトルの変更 */}
	<PageTitle title={pageTitle} />

	
    <div className="modal-detail-container" style={{
      display: 'flex',
      flexDirection: window.innerWidth > 768 ? 'row' : 'column', // PCなら横、スマホなら縦
      alignItems: 'center', // 左右の要素の高さを中央で揃え、矢印の位置を固定する
	  
      gap: '20px',
	  maxWidth:'1800px',
      width: '100%',
      color: 'white',
	  marginTop: window.innerWidth <= 768 ? '40px' : '0' // スマホで画像を下に
    }}>
      
      {/* 左側：画像エリア */}
      <div 
        className="modal-image-wrapper" 
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ 
          flex: '1.5', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          minHeight: '300px',
          backgroundColor: 'rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}
      >
        <AnimatePresence mode="wait" custom={direction}>
          <motion.div
            key={currentImgIdx}
            custom={direction}
            variants={{
              // 現れる時の位置
              enter: (dir) => ({
                // 次へ(1)なら右(40)から、戻る(-1)なら左(-40)から
                x: dir === -1 ? -40 : 40,
                opacity: 0
              }),
              // 定位置
              center: {
                x: 0,
                opacity: 1
              },
              // 消える時の位置
              exit: (dir) => ({
                // 次へ(1)なら左(-40)へ、戻る(-1)なら右(40)へ
                x: dir === 1 ? -40 : 40,
                opacity: 0
              })
            }}
            initial={direction === 0 ? { opacity: 0, x: 0 } : "enter"}
            animate="center"
            exit="exit"
            transition={{ duration: 0.2 }}
            drag={images.length > 1 ? "x" : false}
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={(_, info) => {
              if (images.length <= 1) return;
              if (info.offset.x > 80) { handlePrev(); triggerHaptic(10); }
              else if (info.offset.x < -80) { handleNext(); triggerHaptic(10); }
            }}
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', cursor: images.length > 1 ? 'grab' : 'default' }}
          >
            <a href={images[currentImgIdx]} target="_blank" rel="noopener noreferrer" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <img 
                src={images[currentImgIdx]} 
                alt={`${illust.title} - ${currentImgIdx + 1}`} 
                draggable={false}
                style={{ 
                  maxWidth: '100%',
                  maxHeight: window.innerWidth <= 768 ? '400px' : '800px',
                  height: 'auto', 
                  borderRadius: '8px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                  objectFit: 'contain',
                  userSelect: 'none'
                }} 
              />
            </a>
          </motion.div>
        </AnimatePresence>

        {/* 複数枚ある場合のみナビゲーションを表示 */}
        {images.length > 1 && (
          <>
            {/* 前へボタン */}
            <button 
              className="modal-nav-btn prev"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePrev(); triggerHaptic(10); }}
              style={{
                position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
                background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%',
                width: '60px', height: '60px', cursor: 'pointer', zIndex: 10, fontSize: '3rem',
                opacity: isHovered ? 1 : 0, transition: 'opacity 0.3s',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                paddingBottom: '8px' // 記号が円の中で少し下にズレるのを微調整
              }}
              aria-label="前の画像"
            >
              ‹
            </button>
            {/* 次へボタン */}
            <button 
              className="modal-nav-btn next"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleNext(); triggerHaptic(10); }}
              style={{
                position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%',
                width: '60px', height: '60px', cursor: 'pointer', zIndex: 10, fontSize: '3rem',
                opacity: isHovered ? 1 : 0, transition: 'opacity 0.3s',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                paddingBottom: '8px' // 記号が円の中で少し下にズレるのを微調整
              }}
              aria-label="次の画像"
            >
              ›
            </button>
            
            {/* インジケーター（数字） */}
            <div style={{
              position: 'absolute', top: '10px', right: '10px', transform: 'translateX(-10%)',
              zIndex: 10, background: 'rgba(0,0,0,0.5)', padding: '2px 10px', borderRadius: '15px',
              fontSize: '0.7rem', color: 'white', fontFamily: '"Zen Maru Gothic", sans-serif'
            }}>
              {currentImgIdx + 1} / {images.length}
            </div>
          </>
        )}
      </div>

		{/* 右側：詳細情報エリア */}
		<div style={{ 
			flex: '1', 
			display: 'flex', 
			flexDirection: 'column', 
			justifyContent: 'flex-start',
			padding: window.innerWidth <= 768 ? '20px 10px' : '100px', // スマホでpadding削減
			textAlign: 'left'
		}}>
			<h2 style={{ fontFamily: "Zen Maru Gothic", fontSize: '1.8rem', borderBottom: '1px solid #444', paddingBottom: '10px' }}>
			{illust.title?.trim() || "無題"}
			</h2>
			

			{/* ボタンエリア */}
			<div style={{  display: 'flex', 
				alignItems: window.innerWidth <= 768 ? 'flex-start' : 'center',
				gap: '12px', 
				color: '#888',
				flexWrap: 'wrap', // スマホで折り返し
				flexDirection: window.innerWidth <= 768 ? 'column' : 'row', // スマホでは縦並び
				}}>


					<p style={{ 
								//日付の表示
								fontSize: window.innerWidth <= 768 ? '1rem' : '1rem', 
								color: '#aaa', 
								margin: '0'
							}}>Date: {illust.date || "不明"}</p>



					{/* いいねボタン */}
					<div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
					<button 
						onClick={handleLikeInModal}
						style={{
							background: isAlreadyLiked ? '#ff4d4f' : '#ff4d4f22', // 済みなら塗りつぶし
							border: '1px solid #ff4d4f',
							color: isAlreadyLiked ? '#fff' : '#ff4d4f', // 済みなら白文字
							padding: window.innerWidth <= 768 ? '8px 16px' : '4px 12px', // スマホで大きく
							borderRadius: '20px',
							cursor: 'pointer',
							fontFamily: "Zen Maru Gothic",
							fontSize: window.innerWidth <= 768 ? '1rem' : '0.9rem' // スマホで大きく
						}}
						>
						{isAlreadyLiked ? '❤️' : '❤️'} {likeCount}
					</button>



				<div className='share'>
					<button 
						onClick={() => {
						triggerHaptic(15);
						if (navigator.share) {
							navigator.share({
							title: illust.title || "無題",
							text: illust.comment,
							url: window.location.href, // 今のURLを共有
							});
						} else {
							// PCなどで共有機能がない場合はURLをクリップボードにコピー
							const url = window.location.href;
							
							// navigator.clipboardが使える場合
							if (navigator.clipboard && navigator.clipboard.writeText) {
								navigator.clipboard.writeText(url)
									.then(() => alert("URLをコピーしました！"))
									.catch(() => {
										// フォールバック：古い方法でコピー
										fallbackCopyText(url);
									});
							} else {
								// フォールバック：古い方法でコピー
								fallbackCopyText(url);
							}
						}

						// フォールバック用のコピー関数
						function fallbackCopyText(text: string) {
							const textArea = document.createElement('textarea');
							textArea.value = text;
							textArea.style.position = 'fixed';
							textArea.style.opacity = '0';
							document.body.appendChild(textArea);
							textArea.select();
							try {
								document.execCommand('copy');
								alert("URLをコピーしました！");
							} catch (err) {
								alert("URLのコピーに失敗しました。手動でコピーしてください:\n" + text);
							}
							document.body.removeChild(textArea);
						}
						}}

						style={{
							background: 'none',
							border: '1px solid #00d4ff33',
							cursor: 'pointer',
							color: '#00d4ff',
							fontSize: '0.8rem',
							padding: '8px 12px',
							borderRadius: '20px'
						}}
					>
						{/* 共有ボタン */}
						<span  style={{ marginRight: '4px' }}>🔗</span> 共有 </button>
							
					</div>
				</div>
					
		</div>

		

			<div style={{ 
					flexGrow: 1, 
					margin: '20px 0', 
					lineHeight: '1.8', 
					color: '#ddd', 
					borderBottom: '1px solid #444',
					whiteSpace: 'pre-wrap',
					paddingBottom: window.innerWidth <= 768 ? '15px' : '10px' ,// スマホで下に余白
					fontFamily: "Zen Maru Gothic"
					
				}}>
			{illust.comment}
			</div>


			{/* タグ一覧 */}
			<div style={{ 
					display: 'flex', 
					flexWrap: 'wrap', 
					gap: '8px', 
					marginTop: window.innerWidth <= 768 ? '20px' : '10px' // スマホで上に余白
				}}>
				{illust.tags.map((tagId: string) => (
						<span 
							key={tagId} 
							className="modal-tag"
							onClick={() => {
								// タグをクリックしたらGalleryページに戻り、そのタグで絞り込む
								triggerHaptic(15);
								navigate(`/gallery?tags=${tagId}`);
							}}
						>
						#{getTagLabel(tagId)}
					</span>
				))}
			</div>





		</div>
	</div>
  </Modal>
	);
};


export default ModalDetail;